import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
`;

export const Left = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const FormSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
`;
